/* import __COLOCATED_TEMPLATE__ from './trigger-procedures.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import templateOnly from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
  };
}

const TriggerProcedures = templateOnly<Signature>();
export default TriggerProcedures;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::TriggerProcedures': typeof TriggerProcedures;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/trigger-procedures': typeof TriggerProcedures;
  }
}
